import React from 'react';

const card = {
  background: '#fff',
  borderRadius: 10,
  padding: 24,
  marginBottom: 16,
  boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
};

const th = {
  fontSize: 12,
  fontWeight: 600,
  padding: '8px 10px',
  textAlign: 'left',
  background: '#f8fafc',
  borderBottom: '2px solid #e2e8f0',
};

const td = {
  fontSize: 12,
  padding: '7px 10px',
  borderBottom: '1px solid #e2e8f0',
};

const thR = { ...th, textAlign: 'right' };
const tdR = { ...td, textAlign: 'right' };

export default function InfraTab({
  infraRows, totalInfraMat, totalInfraHrs, totalInfraLabor,
  totalInfraCost, totalInfraSell, laborRate, ohPct, margin,
  NS, C, fmt, fmtHrs, pct,
}) {
  return (
    <div style={{ maxWidth: 960, margin: '0 auto' }}>
      {/* Header */}
      <div style={{ ...card, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ fontSize: 13 }}>
          <strong>{infraRows.length}</strong> infrastructure item{infraRows.length !== 1 ? 's' : ''}
        </div>
        <div style={{ fontSize: 12, color: '#64748b' }}>
          Sections: <strong>{NS}</strong>
        </div>
      </div>

      {/* Table */}
      <div style={{ ...card, padding: 0, overflow: 'hidden' }}>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={th}>Item</th>
                <th style={thR}>Material</th>
                <th style={thR}>Hours</th>
                <th style={th}>Note</th>
              </tr>
            </thead>
            <tbody>
              {infraRows.map((row, i) => (
                <tr
                  key={i}
                  style={{ background: i % 2 === 0 ? '#fff' : '#fafbfc' }}
                >
                  <td style={{ ...td, fontWeight: 600 }}>{row.l || row.item || row.label || '--'}</td>
                  <td style={tdR}>{fmt(row.mat || 0)}</td>
                  <td style={tdR}>{fmtHrs(row.hrs || 0)}</td>
                  <td style={{ ...td, color: '#64748b', fontSize: 11 }}>{row.note || ''}</td>
                </tr>
              ))}
              {infraRows.length === 0 && (
                <tr>
                  <td colSpan={4} style={{ ...td, textAlign: 'center', color: '#94a3b8', padding: 24 }}>
                    No infrastructure items to display.
                  </td>
                </tr>
              )}
            </tbody>
            {infraRows.length > 0 && (
              <tfoot>
                <tr style={{ background: '#f8fafc', fontWeight: 700 }}>
                  <td style={{ ...td, borderTop: '2px solid #e2e8f0' }}>Totals</td>
                  <td style={{ ...tdR, borderTop: '2px solid #e2e8f0' }}>{fmt(totalInfraMat || 0)}</td>
                  <td style={{ ...tdR, borderTop: '2px solid #e2e8f0' }}>{fmtHrs(totalInfraHrs || 0)}</td>
                  <td style={{ ...td, borderTop: '2px solid #e2e8f0' }} />
                </tr>
              </tfoot>
            )}
          </table>
        </div>
      </div>

      {/* Summary card */}
      <div style={card}>
        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 12 }}>Infrastructure Summary</div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16 }}>
          <div>
            <div style={{ fontSize: 11, color: '#64748b', marginBottom: 4 }}>Total Material</div>
            <div style={{ fontSize: 16, fontWeight: 700 }}>{fmt(totalInfraMat || 0)}</div>
          </div>
          <div>
            <div style={{ fontSize: 11, color: '#64748b', marginBottom: 4 }}>Total Labor</div>
            <div style={{ fontSize: 16, fontWeight: 700 }}>{fmt(totalInfraLabor || 0)}</div>
          </div>
          <div>
            <div style={{ fontSize: 11, color: '#64748b', marginBottom: 4 }}>Total Cost</div>
            <div style={{ fontSize: 16, fontWeight: 700, color: C.blue || '#2563eb' }}>{fmt(totalInfraCost || 0)}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
